import { ref } from 'vue';
import { getSeller, getActiveSellers } from '@/services/oto/sellers';
import { map, orderBy } from 'lodash';
import { useToast } from 'vue-toastification';
import i18n from '@/i18n';
export function useSellerData() {
    const sellerDetail = ref(null);
    const alternativeSellers = ref([]);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const toast = useToast();
    async function fetchDetails(sellerId) {
        if (isNaN(Number(sellerId)))
            return;
        isLoading.value = true;
        try {
            const { data: sellerDetails, errors, success } = await getSeller(Number(sellerId));
            if (!success || errors.length) {
                throw new Error(i18n.global.t('errors.err-500'));
            }
            sellerDetail.value = sellerDetails;
            const { data: activeSellers } = await getActiveSellers(Number(sellerDetail.value.store.id));
            alternativeSellers.value = orderBy(map(activeSellers, ({ id, name }) => ({ id, name })), 'name');
        }
        catch (error) {
            toast.error(i18n.global.t('errors.err-500'), {
                timeout: 5000,
            });
        }
        finally {
            isLoading.value = false;
        }
    }
    return {
        isLoading,
        isSubmitting,
        sellerDetail,
        alternativeSellers,
        fetchDetails,
    };
}
